import * as React from "react";
import { Outlet } from "react-router";
import MainLayout from "../../../components/atoms/MainLayout";
import { withRouter } from "../../../helpers/RouterHelper";
import enhanceAuthenticatedPage, {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../../../hocs/enhanceAuthenticatedPage";
import withErrorPages from "../../../hocs/withErrorPages";
import SectionGlobalHeader from "../../SectionGlobalHeader";
import SectionSettingSidebar from "../../SectionSettingSidebar";

export type Props = AuthenticatedPageProps & AuthenticatedPageCallbacks;

const SectionSettingLayout = (props: Props) => {
  const [activeMenu, setActiveMenu] = React.useState<string>("");
  return (
    <MainLayout>
      <SectionSettingSidebar {...props} activeMenu={activeMenu} />
      <SectionGlobalHeader {...props} />
      <Outlet context={{ setActiveMenu }} />
    </MainLayout>
  );
};

export default withRouter(
  withErrorPages(enhanceAuthenticatedPage(SectionSettingLayout)),
);
